const rules = {
	user: {
		static: [],
	},
	
		superv: {
	static: [
	    "drawer-superv-items:view",	
		"tickets:showClosed",
		"ticket-options:deleteTicket",
		"tickets-manager:closeAll",
		"connections-page:actionButtons",
		"menu:superv-only",
        	],
    },

	admin: {
		static: [
			"dashboard:view",
			"drawer-admin-items:view",
			"tickets-manager:showall",
			"user-modal:editProfile",
			"user-modal:editQueues",
			"ticket-options:deleteTicket",
			"contacts-page:deleteContact",
			"connections-page:actionButtons",
			"connections-page:addConnection",
			"connections-page:editOrDeleteConnection",
			"tickets-manager:closeAll",
			"tickets:showPopover",
		],
	},
};

export default rules;
